// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"c82792a9","513":"120eaf04","516":"c82792a9","554":"120eaf04","674":"c82792a9","925":"c82792a9","992":"120eaf04"}[chunkId] + ".chunk.css";
};